import React from "react";
import {
    Checkbox,
    Button,
    ListGroupItem,
    Glyphicon,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap";
import MoveIcon from "../../Widgets/components/Icons/MoveIcon";

export default ({ title, required, disabledTotal, disabled, handleUpdateField, handleDeleteField }) => {

    return <ListGroupItem
        style={{
            padding: '4px 4px 4px 12px',
            display: 'flex',
            justifyContent: 'space-between',
            height: '44px',
            marginBottom: '0.5rem'
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', gap: '0.5rem' }}>
            <div style={{ minWidth: 20 }}>
                {!disabledTotal && <MoveIcon />}
            </div>
            <span style={{maxWidth: '45rem', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{title}</span>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="checkbox-tooltip">
                    Обязательное поле
                </Tooltip>}
            >
                <Checkbox checked={required} disabled={disabledTotal || disabled} onChange={(e) => handleUpdateField({required: e.target.checked})} style={{ margin: 0 }} />
            </OverlayTrigger>
            <Button bsStyle="danger" disabled={disabledTotal || disabled}>
                <Glyphicon glyph="trash" onClick={handleDeleteField} />
            </Button>
        </div>
    </ListGroupItem>
}